export default {
    data: () => ({
        isVisibleDemoModal: false,
    }),

    methods: {
        hasInteractionDemo(item) {
            if (!item?.modal) return false;
            if (!item.modal.id || !item.modal.src) return false;
            if (!item.modal.breakpoint?.length) return true;
            return item.modal.breakpoint.includes(this.currentBreakpoint);
        },
        logInteraction(item) {
            this.isVisibleDemoModal = true;

            const abbr = item.modal?.abbr || 'ACPC';
            const hops = `demoButtonClickHops-${abbr}`;
            const name = `demoButtonClickDate-${abbr}`;

            if (!localStorage.getItem(hops)) localStorage.setItem(hops, 0);
            if (!localStorage.getItem(name)) localStorage.setItem(name, new Date());
        },
    },
};
